import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { CURRENCY } from '../../utils/ConstantsMain';
import {
  InputLabel,
  MenuItem,
  FormHelperText,
  FormControl,
  Select,
  TextField,
  Grid,
  Button,
} from '@material-ui/core';
import './addServices.scss';

const styles = () => ({
  form: {
    padding: 24,
    borderRadius: 4,
    margin: '20px 0 30px 0',
    border: '1px solid #e7e7e7',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 568,
  },
  firstForm: {
    padding: 24,
    borderRadius: 4,
    margin: '0px 0 28px 0',
    border: '1px solid #e7e7e7',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 568,
  },
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 22,
    bottom: 0,
  },
  inputLabelShrink: {
    transform: 'translate(14px, -6px) scale(0.75)',
    zIndex: 10,
    right: 'unset',
    backgroundColor: '#fff',
    height: 'fit-content',
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
  TextField: {
    maxWidth: 520,
    height: 'auto',
    margin: '0 0 6px 0',
    width: '100%',
  },
  TextFieldLeft: {
    maxWidth: 160,
    margin: '0 16px 6px 0',
    width: '100%',
  },
  TextFieldRight: {
    maxWidth: 160,
    margin: '0 0 6px 0',
    width: '100%',
  },
  paragraph: {
    color: '#484848',
    fontSize: 14,
    margin: '0 0 25px',
  },
  deleteActionContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  deleteAction: {
    color: '#d74242',
    fontSize: 12,
    padding: 0,
    textTransform: 'capitalize',
    margin: '0 30px 0 0',
  },
});

const LawyerServicesForm = (props) => {
  const {
    service,
    servicesHelper,
    handleCancel,
    handleChange,
    handleBlur,
    touched,
    errors,
    classes,
    index,
    setFieldValue,
  } = props;

  const deleteSubForm = () => {
    servicesHelper.remove(index);
  };

  const handleChangeDiscount = e => {  
    const newValue = Number(e.target.value)
    if (!service.price || service.price === "") {
      setFieldValue(`services[${index}].discount`, "")
    } else if (service.price && service.price < newValue) {
      setFieldValue(`services[${index}].discount`, parseInt(service.price))
    } else {
      setFieldValue(`services[${index}].discount`, parseInt(newValue))
    }
  }

  const handleChangePrice = e => {
    const newValue = Number(e.target.value)
    if (service.discount && service.discount > newValue) {
      setFieldValue(`services[${index}].price`, parseInt(newValue))
      setFieldValue(`services[${index}].discount`, parseInt(newValue))
    } else {
      setFieldValue(`services[${index}].price`, parseInt(newValue))
    }
  }

  return (
    <div className={index && index !== 0 ? classes.form : classes.firstForm}>
      <Grid container direction="row">
        <TextField
          label="Descripción*"
          name={`services[${index}].description`}
          id="description"
          type="text"
          multiline={true}
          rows="4"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={
            service && service.description
              ? service.description
              : ''
          }
          helperText={
            touched &&
            touched.services &&
            touched.services[index] &&
            touched.services[index].description &&
            errors &&
            errors.services &&
            errors.services[index] &&
            errors.services[index].description
              ? errors.services[index].description
              : ''
          }
          error={
            touched &&
            touched.services &&
            touched.services[index] &&
            touched.services[index].description &&
            errors &&
            errors.services &&
            errors.services[index] &&
            errors.services[index].description
              ? true
              : false
          }
          fullWidth
          classes={{ root: classes.TextField }}
        />
      </Grid>

      <Grid container direction="row">
        <TextField
          label="Precio"
          name={`services[${index}].price`}
          onInput={(e) => {
            e.target.value = Number(e.target.value.replace(/[^0-9]/g, ''));
          }}
          inputProps={{ minLength: 8, maxLength: 10 }}
          id="price"
          type="number"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChangePrice}
          value={service.price}
          helperText={
            touched &&
            touched.services &&
            touched.services[index] &&
            touched.services[index].price &&
            errors &&
            errors.services &&
            errors.services[index] &&
            errors.services[index].price
              ? errors.services[index].price
              : ''
          }
          error={
            touched &&
            touched.services &&
            touched.services[index] &&
            touched.services[index].price &&
            errors &&
            errors.services &&
            errors.services[index] &&
            errors.services[index].price
              ? true
              : false
          }
          fullWidth
          classes={{ root: classes.TextFieldLeft }}
        />

        <FormControl
          classes={{ root: classes.TextFieldLeft }}
          variant="outlined"
          error={touched.Items && errors.Items ? true : false}
        >
          <InputLabel
            htmlFor="select-multiple-checkbox"
            classes={{
              root: classes.inputLabelRoot,
              shrink: classes.inputLabelShrink,
            }}
          >
            {'Tipo de moneda'}
          </InputLabel>
          <Select
            id="typeCurrency"
            name={`services[${index}].typeCurrency`}
            value={
              // service && service.typeCurrency ? service.typeCurrency : []
              'MXN Peso mexicano'
            }
            onChange={handleChange}
            disabled={true}
          >
            {CURRENCY &&
              CURRENCY.map((item, index) => (
                <MenuItem key={index} value={item.value}>
                  {item.name}
                </MenuItem>
              ))}
          </Select>
          {touched &&
          touched.services &&
          touched.services[index] &&
          touched.services[index].typeCurrency &&
          errors &&
          errors.services &&
          errors.services[index].typeCurrency ? (
            <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
              {errors.services[index].typeCurrency}
            </FormHelperText>
          ) : (
            ''
          )}
        </FormControl>

        <TextField
          label="Descuento"
          name={`services[${index}].discount`}
          id="discount"
          onInput={(e) => {
            e.target.value = Number(e.target.value.replace(/[^0-9]/g, ''));
          }}
          inputProps={{ minLength: 8, maxLength: 10 }}
          type="number"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChangeDiscount}
          value={service.discount}
          helperText={
            touched &&
            touched.services &&
            touched.services[index] &&
            touched.services[index].discount &&
            errors &&
            errors.services &&
            errors.services[index] &&
            errors.services[index].discount
              ? errors.services[index].discount
              : ''
          }
          error={
            touched &&
            touched.services &&
            touched.services[index] &&
            touched.services[index].discount &&
            errors &&
            errors.services &&
            errors.services[index] &&
            errors.services[index].discount
              ? true
              : false
          }
          fullWidth
          classes={{ root: classes.TextFieldRight }}
        />
      </Grid>

      {index && index !== 0 ? (
        <div className={classes.deleteActionContainer}>
          <Button
            key={index}
            component="span"
            type="button"
            onClick={index && index !== 0 ? deleteSubForm : handleCancel}
            className={classes.deleteAction}
          >
            Eliminar
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default withStyles(styles)(LawyerServicesForm);
